<template>
  <wrap-container>
    <help-title title="Desconocimiento de consumo" />

    <help-list-container>
      <help-list-item tituloLista="¿Cómo tengo que hacer?:">
        Ingresando en Banca Online con tu Usuario y Clave digital por las
        opciones <br />
        <strong
          >Tarjetas ➜ Consumos ➜ Mis movimientos ➜ Últimos Movimientos ➜
          Seleccionar periodo de resumen ➜ Iniciar Reclamo.</strong
        >
      </help-list-item>
      <help-list-item
        tituloLista="Realizar el desconocimiento con la
        marca de tu Tarjeta de Crédito:"
      >
        <strong>Visa</strong> <br />
        - Classic 4379-3400 <br />
        - Oro 4378-4444 <br />
        - Platinum 0-800-333-7528 <br />
        - Signature 0-800-222-7446.<br />
        <br />
        <strong>MasterCard</strong> <br />
        - Classic 4348-7000 <br />
        - Gold 4348-7007 <br />
        - Platinum: 0800-999-3999 <br />
        - Black: 0800-999-3297.<br />
        <br />
        <strong>Visa Home</strong><br />
        - Ingresa con tu usuario y clave menú
        <strong>"Gestionar" - "Denuncia"</strong><br />
        <br />
        En caso de ser necesario, la marca bloqueará la tarjeta y emitirá un
        nuevo plástico que recibirás en tu domicilio registrado en el banco.
      </help-list-item>
      <help-list-item tituloLista="¿No resolvimos tu consulta?">
        Podés dejar tus datos y un representante se podrá en contacto a la
        brevedad.
        <p id="contactForm" @click="contacto">Quiero que me contacten</p>
        <div v-if="show">
          <br />
          <formulario-contacto />
        </div>
      </help-list-item>
    </help-list-container>
  </wrap-container>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import HelpTitle from "@/components/core/HelpTitle";
import HelpListItem from "@/components/core/HelpListItem";
import HelpListContainer from "@/components/core/HelpListContainer";
import FormularioContacto from "@/views/segments/subSegments/FormularioContacto.vue";

export default {
  components: {
    WrapContainer,
    HelpTitle,
    HelpListItem,
    HelpListContainer,
    FormularioContacto
  },
  data() {
    return {
      show: false
    };
  },
  methods: {
    contacto: function() {
      this.show = true;
    }
  }
};
</script>

<style>
#contactForm {
  font-family: BentonSansBBVA-Medium, Helvetica, Arial, sans-serif;
  font-size: 15px;
  color: #1973b8;
  text-decoration: none;
  cursor: pointer;
}
</style>
